import {collection,onSnapshot} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';

// Match-level points are read once, irrespective of the number of POVs.
// Standalone video collections remain supported for older recordings.
export default function subscribeStudioFocus(teamId,onPoints,onState) {
  let alive=true;
  const buckets=new Map(),listeners=new Map(),pending=new Set(),metadataByPath=new Map();
  const publish=()=>{if(alive){onPoints([...buckets.values()].flat());onState({loading:pending.size>0});}};
  const stopPrefix=prefix=>{for(const [path,stop] of listeners)if(path.startsWith(prefix)){stop();listeners.delete(path);buckets.delete(path);pending.delete(path);metadataByPath.delete(path);}};
  function listen(path,callback){pending.add(path);listeners.set(path,onSnapshot(collection(db,...path.split('/')),snapshot=>{if(!alive || !listeners.has(path))return;pending.delete(path);callback(snapshot);publish();},error=>{if(!alive || !listeners.has(path))return;pending.delete(path);buckets.delete(path);onState({error:'Some review data could not be loaded: '+error.message});publish();}));}
  const base=`teams/${teamId}/maps`;
  listen(base,snapshot=>{
    const maps=[...snapshot.docs];
    for(const map of snapshot.docs){const name=map.data().name;if(name&&name!==map.id&&!snapshot.docs.some(other=>other.id===name))maps.push({id:name,data:()=>map.data()});}
    const prefixes=maps.map(map=>`${base}/${map.id}/`);
    for(const path of [...listeners.keys()])if(path!==base && !prefixes.some(prefix=>path.startsWith(prefix)))stopPrefix(path);
    maps.forEach(map=>{
      for(const kind of ['matches','videos']) {
        const parentPath=`${base}/${map.id}/${kind}`;
        if(listeners.has(parentPath))continue;
        listen(parentPath,parents=>{
          const valid=parents.docs.filter(parent=>kind==='matches'||!parent.data().matchId);
          const paths=valid.map(parent=>`${parentPath}/${parent.id}/focusPoints`);
          for(const path of [...listeners.keys()])if(path.startsWith(parentPath+'/')&&!paths.includes(path))stopPrefix(path);
          valid.forEach(parent=>{
            const path=`${parentPath}/${parent.id}/focusPoints`,metadata={reviewId:parent.id,reviewMapId:map.id,reviewMapName:map.data().name || map.id,kind,parent:parent.data(),path};
            metadataByPath.set(path,metadata);
            if(listeners.has(path)) {buckets.set(path,(buckets.get(path)||[]).map(point=>({...point,...metadata})));return;}
            listen(path,points=>buckets.set(path,points.docs.map(point=>({...point.data(),id:point.id,...metadataByPath.get(path)}))));
          });
        });
      }
    });
  });
  return ()=>{alive=false;for(const stop of listeners.values())stop();listeners.clear();};
}
